import api from './api';
import type { Customer, PaginatedResponse } from '../types';

interface ListCustomersParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  partnerId?: string;
  search?: string;
}

interface CreateCustomerInput {
  userId: string;
  name: string;
  phone?: string;
  company?: string;
  address?: string;
  partnerId?: string;
}

export interface LinkableCustomerUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

interface UpdateCustomerInput {
  name?: string;
  email?: string;
  phone?: string;
  company?: string;
  address?: string;
  partnerId?: string | null;
  isActive?: boolean;
}

export async function listCustomers(params: ListCustomersParams = {}): Promise<PaginatedResponse<Customer>> {
  const response = await api.get<PaginatedResponse<Customer>>('/customers', { params });
  return response.data;
}

export async function getCustomer(id: string): Promise<Customer> {
  const response = await api.get<Customer>(`/customers/${id}`);
  return response.data;
}

export async function getLinkableCustomerUsers(): Promise<LinkableCustomerUser[]> {
  const response = await api.get<LinkableCustomerUser[]>('/customers/linkable-users');
  return response.data;
}

export async function createCustomer(data: CreateCustomerInput): Promise<Customer> {
  const response = await api.post<Customer>('/customers', data);
  return response.data;
}

export async function updateCustomer(id: string, data: UpdateCustomerInput): Promise<Customer> {
  const response = await api.put<Customer>(`/customers/${id}`, data);
  return response.data;
}

export async function deleteCustomer(id: string): Promise<void> {
  await api.delete(`/customers/${id}`);
}
